import { useTranslation } from 'react-i18next';
import { useAppScopeStore } from '@frontend/scope';
import { Chip, TextLink } from '@frontend/design-system';
import { SettingsLocationChipStyles } from './settings-location-chip.styles';

export type SettingsLocationChipProps = {
  isSingleLocation?: boolean;
  chipLabel?: string;
  onActionClick?: React.MouseEventHandler<HTMLElement> & React.MouseEventHandler<HTMLAnchorElement>;
  actionLabel?: string;
  hideLocationChip?: boolean;
};

export function SettingsLocationChip({
  isSingleLocation,
  chipLabel,
  onActionClick,
  actionLabel,
  hideLocationChip,
}: SettingsLocationChipProps) {
  const { t } = useTranslation('base');
  const { selectedLocationIds, getLocationName, isSingleTypeScope } = useAppScopeStore();

  if (isSingleTypeScope || hideLocationChip) return null;
  const singleLocationId = selectedLocationIds[0];
  const shouldRenderSingleChip = isSingleLocation ?? selectedLocationIds?.length === 1;

  return (
    <div className={SettingsLocationChipStyles.settingsLocationChipDivStyle1}>
      {shouldRenderSingleChip && singleLocationId ? (
        <Chip.SingleChip>{chipLabel || getLocationName(singleLocationId)}</Chip.SingleChip>
      ) : (
        <Chip.MultiChip>{chipLabel || t(`{{count}} Locations`, { count: selectedLocationIds.length })}</Chip.MultiChip>
      )}
      {onActionClick ? (
        <TextLink
          weight='bold'
          className={SettingsLocationChipStyles.settingsLocationChipTextLinkStyle2}
          onClick={(e) => {
            onActionClick?.(e);
          }}
        >
          {actionLabel ?? t('Edit')}
        </TextLink>
      ) : null}
    </div>
  );
}
